const HOUMAO_CANONICAL_ORIGIN = 'https://houmao.com';
const HOUMAO_CANONICAL_HOSTS = new Set([
  'houmao.com',
  'www.houmao.com',
  'agent.huobanniu.top',
]);

const PUBLIC_CANONICAL_PATHS = new Map([
  ['/', '/'],
  ['/experts', '/experts'],
]);

export function buildPublicCanonicalUrl(pathname: string, origin: string): string | null {
  const pathWithoutQuery = pathname.split(/[?#]/, 1)[0] || '/';
  const normalizedPath = pathWithoutQuery.length > 1
    ? pathWithoutQuery.replace(/\/+$/, '')
    : pathWithoutQuery;
  const canonicalPath = PUBLIC_CANONICAL_PATHS.get(normalizedPath);
  if (!canonicalPath) return null;

  return `${resolveCanonicalOrigin(origin)}${canonicalPath}`;
}

export function syncPublicCanonicalLink(pathname: string, origin: string): string | null {
  if (typeof document === 'undefined') return null;

  const canonicalUrl = buildPublicCanonicalUrl(pathname, origin);
  const existing = Array.from(
    document.head.querySelectorAll<HTMLLinkElement>('link[rel="canonical"]'),
  );

  if (!canonicalUrl) {
    existing.forEach((link) => link.remove());
    return null;
  }

  const canonicalLink = existing.shift() ?? document.createElement('link');
  canonicalLink.rel = 'canonical';
  canonicalLink.href = canonicalUrl;
  canonicalLink.setAttribute('data-houmao-canonical', '');
  if (!canonicalLink.isConnected) document.head.appendChild(canonicalLink);
  existing.forEach((link) => link.remove());
  return canonicalUrl;
}

function resolveCanonicalOrigin(origin: string): string {
  try {
    const parsed = new URL(origin);
    if (HOUMAO_CANONICAL_HOSTS.has(parsed.hostname.toLowerCase())) {
      return HOUMAO_CANONICAL_ORIGIN;
    }
    if (parsed.protocol === 'https:' && !parsed.username && !parsed.password) {
      return parsed.origin;
    }
  } catch {
    // Fall through to the production origin for malformed or non-HTTPS input.
  }
  return HOUMAO_CANONICAL_ORIGIN;
}
